<div class="cardHeader" data-automation-e2e-selector="fullCardHeaderText">
  <div *ngIf="!!entity" class="entity">
    <div class="name">
      <span
        [textContent]="entity.name"
        [attr.title]="entity.name"
        data-automation-e2e-selector="entityName"
      >
      </span>
    </div>

    <muni-gameday-profile-overview-open-link
      *ngIf="showLink"
      [text]="entity.name"
      [cropped]="false"
      [linkType]="'account'"
      [displayText]="false"
    >
      <i
        class="fa fa-list-alt"
        (click)="preventClickEvent($event)"
        [ngClass]="{ disableIcon: !isLinkClickable }"
        data-automation-e2e-selector="faListAlt"
        [title]="getTitle()"
      ></i>
    </muni-gameday-profile-overview-open-link>

    <span *ngIf="!maturity" class="metrics">
      <span
        [textContent]="orderCountFormatted"
        data-automation-e2e-selector="orderCount"
      >
      </span>
      <span class="title"> Orders </span>
      <span
        [textContent]="amountFormatted"
        data-automation-e2e-selector="amount"
      >
      </span>
      <span class="title"> ($M) </span>
      <span *ngIf="isOrderPeriodClosed">
        <i [ngClass]="['fa', 'lock']" data-icon></i>
      </span>
    </span>
  </div>

  <div *ngIf="maturity" class="tranche" [class.title]="entity">
    <span class="series">
      <span
        [textContent]="series"
        [attr.title]="series"
        data-automation-e2e-selector="series"
      >
      </span> </span
    ><span
      >:
      <span
        [textContent]="maturity"
        data-automation-e2e-selector="maturityDate"
      >
      </span></span
    ><span *ngIf="coupons"
      >,
      <span [textContent]="coupons" data-automation-e2e-selector="coupon">
      </span>
    </span>
    <span
      [textContent]="securityTypeCode"
      data-automation-e2e-selector="securityTypeCode"
    ></span>
    <span
      class="maturityClosed"
      *ngIf="isOrderPeriodTerminated"
      data-automation-e2e-selector="maturityClosedIndicator"
    >
      <i class="fa fa-lock" data-icon></i>
    </span>
  </div>
</div>
